// packages import
import { FC } from 'react'
import { Typography, TableCell, TableRow, Checkbox, styled } from '@mui/material'

// others
import { BillableCaseDetail } from '../../../../generated'
import { formatCurrency } from '../../../utils'

interface BillingTypeRowProps {
  title: string
  cases: BillableCaseDetail[]
  selectedCases: string[]
  onCaseSelect: (caseId: string, checked: boolean) => void
}

const CustomTableCell = styled(TableCell)(({ theme }) => ({
  paddingTop: theme.spacing(0),
  paddingBottom: theme.spacing(0),
  border: 'none'
}))

const BillingTypeRow: FC<BillingTypeRowProps> = ({ title, cases, selectedCases, onCaseSelect }) => {
  if (!cases || cases.length === 0) {
    return null
  }

  return (
    <>
      <TableRow>
        <CustomTableCell
          colSpan={4}
          sx={{
            p: 1.5,
            pt: 3
          }}
        >
          <Typography
            sx={{
              color: 'primary.main',
              fontWeight: 700
            }}
          >
            {title}
          </Typography>
        </CustomTableCell>
      </TableRow>

      {cases.map(caseItem => {
        const { caseId, caseNumber, consultMatterNumber, title, totalUnbilledHours, totalAmount } = caseItem

        return (
          <TableRow key={caseId}>
            <CustomTableCell align="left" sx={{ px: 0 }}>
              <Checkbox
                checked={selectedCases.includes(caseId)}
                onChange={e => onCaseSelect(caseId, e.target.checked)}
              />
            </CustomTableCell>
            <CustomTableCell align="left" sx={{ pl: 0 }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                #{caseNumber || consultMatterNumber} - {title}
              </Typography>
            </CustomTableCell>
            <CustomTableCell align="center">
              <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                {totalUnbilledHours > 0 ? totalUnbilledHours.toFixed(2) : '-'}
              </Typography>
            </CustomTableCell>
            <CustomTableCell align="center">
              <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>{formatCurrency(totalAmount)}</Typography>
            </CustomTableCell>
          </TableRow>
        )
      })}
    </>
  )
}

export default BillingTypeRow
